// ** List Invoice Patients
export const LIST_INVOICE_PATIENTS_REQUEST = 'LIST_INVOICE_PATIENTS_REQUEST'
export const LIST_INVOICE_PATIENTS_SUCCESS = 'LIST_INVOICE_PATIENTS_SUCCESS'
export const LIST_INVOICE_PATIENTS_FAIL = 'LIST_INVOICE_PATIENTS_FAIL'

// ** History Log Invoice Patients
export const HISTORY_LOG_INVOICE_PATIENTS_REQUEST = 'HISTORY_LOG_INVOICE_PATIENTS_REQUEST'
export const HISTORY_LOG_INVOICE_PATIENTS_SUCCESS = 'HISTORY_LOG_INVOICE_PATIENTS_SUCCESS'
export const HISTORY_LOG_INVOICE_PATIENTS_FAIL = 'HISTORY_LOG_INVOICE_PATIENTS_FAIL'
